module.exports = __webpack_public_path__ + "media/customizations/cai/back-e35190d0699a50679712cbb41f7b56d4.jpg";